import React from 'react';
import Svg, { Path } from 'react-native-svg';

/**
 * PlusIcon
 *
 * A React Native SVG icon representing a plus symbol.
 * Can be used for "add", "create", or "expand" actions.
 */
const PlusIcon = ({size = 16, color = '#1434CB'}: {size?: number, color?: string}) => (
  <Svg width={size} height={size} viewBox="0 0 12 11" fill="none">
    <Path
      d="M1.5 5.5h9M6 10V1"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default PlusIcon;
